import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            SI Düsseldorf
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#adventskalender" className="page-scroll">
                Adventskalender
              </a>
            </li>
            <li>
              <a href="#rules" className="page-scroll">
                Ausspielungsverfahren
              </a>
            </li>
            <li>
              <a href="#recipient" className="page-scroll">
                Wofür wir sammeln
              </a>
            </li>
            <li>
              <a href="#sponsors" className="page-scroll">
                Sponsoren
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Über Uns
              </a>
            </li>
            <li>
              <a href="#impressum" className="page-scroll">
                Impressum/Datenschutz
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
